import Env from '../../util/env';
import {contactDBRoutes, serviceURL, source} from '../../util/uiconstants';
import {USER} from '../../components/Pages/ContactDB/Toolbar/AddContact/ACForm/utils/constants';
import {
	ADD_ALL_POTENTIAL_CONTACTS_TO_ADD,
	ADD_POTENTIAL_CONTACT,
	GET_POTENTIAL_CONTACTS_TO_ADD,
	GET_POTENTIAL_CONTACTS_TO_REMOVE,
	IGNORE_ALL_POTENTIAL_CONTACTS_TO_ADD,
	IGNORE_ALL_POTENTIAL_CONTACTS_TO_REMOVE,
	IGNORE_POTENTIAL_CONTACT_TO_ADD,
	IGNORE_POTENTIAL_CONTACT_TO_REMOVE,
	REMOVE_POTENTIAL_CONTACT
} from '../actiontypes';

const getURL = (projectId, add = false) =>
	`${Env.getBaseURL(serviceURL)}${contactDBRoutes.projects}/${projectId}/${
		contactDBRoutes.potentialContactacts
	}?potentialToAdd=${add}`;

export const getContactsToAdd = (projectId, orgChart) => {
	const url = getURL(projectId, true);
	return {
		type: GET_POTENTIAL_CONTACTS_TO_ADD,
		orgChart,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const getContactsToRemove = (projectId, orgChart) => {
	const url = getURL(projectId);
	return {
		type: GET_POTENTIAL_CONTACTS_TO_REMOVE,
		orgChart,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const ignoreContactToAdd = (projectId, contactId, contact, entityId) => {
	let url = `${Env.getBaseURL(serviceURL)}
		${contactDBRoutes.projects}/${projectId}/${contactDBRoutes.entities}/${entityId}`;

	const contactToIgnore = {...contact, isIgnored: true};

	const data = {
		contacts: [contactToIgnore],
		source: source.accessLog,
		userLevelAccess: USER
	};

	return {
		type: IGNORE_POTENTIAL_CONTACT_TO_ADD,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		},
		contactId,
		entityId
	};
};

export const addPotentialContact = (projectId, contactId, contact, entityId) => {
	let url = `${Env.getBaseURL(serviceURL)}
		${contactDBRoutes.projects}/${projectId}/${contactDBRoutes.entities}/${entityId}`;

	const contactToAdd = {...contact, isIgnored: false};

	const data = {
		contacts: [contactToAdd],
		source: source.accessLog,
		contactList: {
			hasAccess: false
		},
		userLevelAccess: USER
	};

	return {
		type: ADD_POTENTIAL_CONTACT,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		},
		contactId,
		entityId,
		contact
	};
};

export const ignoreAllPotentialContactsToAdd = (projectId, contacts, entityId) => {
	let url = `${Env.getBaseURL(serviceURL)}
	${contactDBRoutes.projects}/${projectId}/${contactDBRoutes.entities}/${entityId}`;

	const data = {
		contacts: contacts.map((contact) => {
			return {...contact, isIgnored: true};
		}),
		source: source.accessLog,
		userLevelAccess: USER
	};

	return {
		type: IGNORE_ALL_POTENTIAL_CONTACTS_TO_ADD,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		},
		entityId
	};
};

export const addAllPotentialContacts = (projectId, contacts, entityId) => {
	let url = `${Env.getBaseURL(serviceURL)}
		${contactDBRoutes.projects}/${projectId}/${contactDBRoutes.entities}/${entityId}`;

	const data = {
		contacts: contacts.map((contact) => {
			return {...contact, isIgnored: false};
		}),
		source: source.accessLog,
		contactList: {
			hasAccess: false
		},
		userLevelAccess: USER
	};

	return {
		type: ADD_ALL_POTENTIAL_CONTACTS_TO_ADD,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		},
		entityId
	};
};

export const ignoreContactToRemove = (projectId, contact, entityId) => {
	let url = `${Env.getBaseURL(serviceURL)}
	${contactDBRoutes.projects}/${projectId}/${contactDBRoutes.entities}/${entityId}/${contactDBRoutes.contactsDelete}`;
	const contactId = contact.userId;
	const data = {
		entity: [{entityId: entityId, contactIds: [contactId]}],
		isRemoveIgnored: true,
		source: source.accessLog
	};

	return {
		type: IGNORE_POTENTIAL_CONTACT_TO_REMOVE,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		},
		contactId,
		entityId
	};
};

export const removePotentialContact = (projectId, contact, entityId) => {
	let url = `${Env.getBaseURL(serviceURL)}
	${contactDBRoutes.projects}/${projectId}/${contactDBRoutes.entities}/${entityId}/${contactDBRoutes.contactsDelete}`;
	const contactId = contact.userId;
	const data = {
		entity: [{entityId: entityId, contactIds: [contactId]}],
		source: source.accessLog
	};

	return {
		type: IGNORE_POTENTIAL_CONTACT_TO_REMOVE,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		},
		contactId,
		entityId
	};
};

export const ignoreAllContactsToRemove = (projectId, contacts, entityId) => {
	let url = `${Env.getBaseURL(serviceURL)}
	${contactDBRoutes.projects}/${projectId}/${contactDBRoutes.entities}/${entityId}/${contactDBRoutes.contactsDelete}`;

	const contactsData = contacts.map((c) => {
		return c.userId;
	});

	const data = {
		entity: [{entityId: entityId, contactIds: contactsData}],
		isRemoveIgnored: true,
		source: source.accessLog
	};

	return {
		type: IGNORE_POTENTIAL_CONTACT_TO_REMOVE,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		},
		entityId
	};
};

export const removeAllPotentialContactsToRemove = (projectId, contacts, entityId) => {
	let url = `${Env.getBaseURL(serviceURL)}
	${contactDBRoutes.projects}/${projectId}/${contactDBRoutes.entities}/${entityId}/${contactDBRoutes.contactsDelete}`;

	const contactsData = contacts.map((c) => {
		return c.userId;
	});

	const data = {
		entity: [{entityId: entityId, contactIds: contactsData}],
		source: source.accessLog
	};

	return {
		type: IGNORE_ALL_POTENTIAL_CONTACTS_TO_REMOVE,
		meta: {
			api: {
				url,
				method: 'POST',
				data
			}
		},
		entityId
	};
};
